import { TextCustom } from '../../../atoms';

export function CardProximamente() {
  const Proteccion =
    'https://aseguramecr.s3.us-east-2.amazonaws.com/Imagenes/Proximamente/Icono-ProteccionMultiple.webp';

  return (
    <div className="flex flex-col items-center">
      <div className="bg-card card-seguros-home flex justify-center items-center px-0 py-0 cursor-pointer hover:scale-105 transition-all duration-300 w-[75px] h-[75px] md:w-[85px] md:h-[85px] max-[]: lg:grid lg:grid-cols-2 lg:w-[250px] lg:h-[125px] lg:px-7 lg:py-3 xl:grid xl:grid-cols-2 xl:w-[300px] xl:h-[125px] xl:px-9 xl:py-5">
        <div>
          <TextCustom
            text="Seguro de"
            className="hidden text-xs fontPRegular color-primary lg:block"
            component="p"
            variant="p"
          />
          <TextCustom
            text="Protección Múltiple"
            className="hidden fontPSemiBold color-primary lg:text-md xl:text-xl text-nombre-seguro lg:block"
            component="p"
            variant="p"
          />
          <TextCustom
            text="Próximamente"
            className="hidden text-xs fontPRegular font-light color-tertiary xl:block lg:block"
            component="p"
            variant="p"
          />
        </div>
        <div className="flex justify-center items-center xl:justify-end xl:items-center lg:justify-end lg:items-center">
          <img
            id="proteccion"
            src={Proteccion}
            alt="asegurameProteccion"
            className="icono-cotizar"
          />
        </div>
      </div>
    </div>
  );
}
